import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import ZoomBox from 'components/zoomSection/zoomSection'
import AnchorButtonContext from 'contexts/anchorButton'
import { useCounterContext } from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
import ManuelOperateur from './manuelOperateur/manuelOperateur'
import './moulage.scss'
export default function Moulage() {
   const { setCounter, counterDefault } = useCounterContext()
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(
         'Moulage <br><span style="fontSize: 35pt;">(Manuel Opérateur / Qualité)</span>',
      )
      setAnchorButton([
         'Manuel<br> opérateur',
         'Contrôle qualité',
      ])
   }, [])

   return (
      <ScrollContainer>
         <div>
            {<AnchorPart anchor={{ partName: 'MANUEL OPÉRATEUR', id: 0 }} />}
            <ManuelOperateur />
         </div>
         <AnchorPart anchor={{ partName: 'CONTRÔLE QUALITÉ', id: 1 }} />
         <ScrollSection zoneName='Contrôle qualité'  />
      </ScrollContainer>
   )
}